import { FC } from 'react'
import { Typography } from '@mui/material'
import { DialogNames } from 'src/enums'
import { SensorModal } from './sensorModal'

interface Props {
  projectName: string
  onSubmit: () => void
  onCancel: () => void
  isLoading?: boolean
}

export const DisconnectSensorModal: FC<Props> = ({ projectName, onSubmit, onCancel, isLoading = false }) => {
  return (
    <SensorModal
      dialogName={DialogNames.DisconnectSensor}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
      actionButtonName="Disconnect"
      content={<Typography variant="h6">Attention: The sensor will be disconnected from the {projectName} project. Are you sure you want to proceed?</Typography>}
    />
  )
}
